@let certification = this.certification();

<div class="border-grey-3 p-lg flex justify-between border-b bg-white">
  <div>
    <div class="flex items-center gap-4">
      <a
        [routerLink]="['..']"
        hlmBtn
        variant="ghost"
        size="icon"
        aria-label="Revenir à la liste des certifications"
        hlmTooltipTrigger="Revenir à la liste des certifications"
      >
        <ng-icon name="lucideArrowLeft" />
      </a>
      <p class="title-medium-semibold">Croisement des référentiels</p>
      <app-croisement-etat [etat]="certification.etatCroisement" />
    </div>
    <p class="text-content-secondary paragraph-medium-medium ml-xxl">{{ certification.nom }}</p>
  </div>
  @if (estVerrouille()) {
    <app-chip label="Verrouillé" variant="warning" />
  }
</div>

<div class="py-lg px-xl gap-sm grid">
  <p class="title-small-medium text-primary-dark">
    Référentiel de certification &nbsp;&bull;&nbsp;<a
      [href]="urlFranceCompetencesRecherche + (certification.codeFiche | getIdFiche)"
      target="_blank"
      hlmBtn
      variant="link"
      size="compact"
      >Lien vers France Compétences</a
    >
  </p>

  @for (bloc of blocsCompetences() | trierPar: 'codeBloc'; track bloc.id; let first = $first) {
    <app-expansion-panel
      [titre]="bloc.codeBloc + ' - ' + bloc.nom"
      [id]="'bloc-' + bloc.id"
      [isOpen]="first"
      [item]="bloc"
      [actions]="actionBlocCompetences()"
    >
      <app-bloc-etat [etat]="bloc.etat" ngProjectAs="chipRight"></app-bloc-etat>
      <div class="p-xs flex">
        <div class="px-sm pb-sm w-1/2">
          <p class="paragraph-large-semibold pb-xs">Compétences</p>
          <p
            class="paragraph-large-medium text-grey-10"
            [innerHTML]="bloc.listeCompetences"
            style="white-space: pre-line"
          ></p>
        </div>
        <div class="border-grey-3 border-r"></div>
        <div class="px-sm pb-sm w-1/2">
          <p class="paragraph-large-semibold pb-xs">Aptitudes associées</p>
          <div class="gap-xs flex flex-1 flex-col">
            @for (aptitude of getAllAptitudesBloc(bloc); track $index) {
              <label [for]="aptitude.id" hlmLabel>
                <span class="text-grey-7 items-center uppercase"
                  >{{ aptitude.referentiel }}
                  &nbsp;&bull;&nbsp;
                </span>
                {{ aptitude.nom }}</label
              >
            } @empty {
              <span class="text-content-secondary paragraph-medium-medium"
                >Il n’y a pas encore d’aptitudes associées.</span
              >
            }
          </div>
        </div>
      </div>
    </app-expansion-panel>
  }
</div>

<div class="gap-sm px-xl py-sm border-grey-3 fixed right-0 bottom-0 left-0 flex border-t bg-white">
  @if (peutModifier()) {
    <button (click)="toggleValidation('Terminé')" hlmBtn type="button">
      Valider le croisement
      <ng-icon name="lucideCheck" />
    </button>
  } @else {
    <button (click)="toggleValidation('En cours')" hlmBtn type="button">
      <ng-icon name="lucidePen" />
      Reprendre la modification du croisement
    </button>
  }
</div>
